<template>
  <div class="dialog_container">
    <el-dialog
      title="新增业户变更信息"
      :visible="dialogShow"
      width="540px"
      @close="dialogClose"
      top="25vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form ref="form" :model="redactForm" label-width="130px">
          <el-form-item label="姓名：">
            <el-input
              v-model="redactForm.theme"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input
              v-model="redactForm.theme"
              placeholder="身份证号"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input
              v-model="redactForm.theme"
              placeholder="请输入联系方式"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位类别：">
            <el-input
              v-model="redactForm.theme"
              placeholder="请输入岗位类别"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="名称变更日期：">
            <el-input
              v-model="redactForm.theme"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      textarea: "",
      redactForm: {},
      receiveList: [],
      qualityGradeList: [
        {
          value: 1,
          label: "AAA",
        },
        {
          value: 2,
          label: "BBB",
        },
        {
          value: 3,
          label: "CCC",
        },
        {
          value: 4,
          label: "DDD",
        },
        {
          value: 5,
          label: "EEE",
        },
      ],
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    confirm() {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/addResidInfo.vue